import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { ListRequestParams } from 'modules/domain/types'
import { MovementsTabTypes, MovementType } from 'modules/domain/warehouses/types'
import { endpoints } from 'modules/endpoints'
import { TableFiltersProps } from 'modules/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AClearFiltersButton, ASelectFilter } from 'views/components/Analytics'
import { FiltersAndSearchWrapper, FiltersWrapper } from 'views/components/CommonTableComponents/CommonTableComponents'
import { MonthFilter } from 'views/components/MonthFilter/MonthFilter'
import { SearchFilter } from 'views/components/SearchFilter/SearchFilter'
import { CropsFilter } from 'views/components/TableFilters'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { BidOption } from 'views/pages/Deal/components/BidOption/BidOption'

type Props = Omit<TableFiltersProps, 'setListRequestParams'> & {
  defaultListParams: Partial<ListRequestParams>
  clearTabState: (params: Partial<ListRequestParams>) => void
  warehouseId: number
  activeTab: string
}

export const WarehouseDetailFilters: FC<Props> = ({
  listRequestParams,
  updateFilterState,
  clearTabState,
  defaultListParams,
  activeTab,
  warehouseId,
}) => {
  const { t } = useTranslation(['common', 'warehouses'])

  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
  })
  const movementsOptions = [
    { value: MovementType.income, label: t('warehouses:movements.income') },
    { value: MovementType.outcome, label: t('warehouses:movements.outcome') },
  ]

  return (
    <FiltersAndSearchWrapper>
      <FiltersWrapper>
        <MonthFilter
          placeholder={t('forEntirePeriod')}
          value={listRequestParams.filter.month}
          updateFilterState={updateFilterState}
        />
        <CropsFilter
          placeholder={t('filtersLabel.allProducts')}
          listRequestParams={listRequestParams}
          updateFilterState={updateFilterState}
        />
        <ABaseTableFilter
          onChange={(sale_bid_id) => updateFilterState({ sale_bid_id })}
          value={listRequestParams.filter.sale_bid_id}
          placeholder={t('common:bid')}
          endpoint={`${endpoints.bid()}?bid_type=sale&warehouse_id=${warehouseId}`}
          getLabel={(record) => `${t('common:bid')} ${record.id}`}
          id="bidFilter"
          OptionComponent={BidOption}
          searchField="search"
        />
        {activeTab == MovementsTabTypes.ungrouped && (
          <ASelectFilter
            id="movementTypeFilter"
            onChange={(movement_type) => updateFilterState({ movement_type: movement_type })}
            value={listRequestParams.filter.movement_type}
            options={movementsOptions}
            placeholder={t('warehouses:detail.income/outcome')}
          />
        )}
        {displayClearBtn && (
          <AClearFiltersButton onClick={() => clearTabState({ ...defaultListRequestParams, ...defaultListParams })} />
        )}
      </FiltersWrapper>
      <SearchFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
    </FiltersAndSearchWrapper>
  )
}
